import axios from 'axios';
import tokenStore from './tokenStore.js';
import router from '../../src/router';

const proxy = axios.create({});

// proxy.defaults.baseURL = 'http://localhost:52725'
proxy.defaults.baseURL = 'https://demo-hairtalk-api.evertop.pl' 
 
proxy.interceptors.request.use(config => {
    var token = tokenStore.getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

proxy.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            router.push({ path: '/login' });
        }

        else {
            return new Promise((resolve, reject) => {
                reject(error);
            });
        }
    })

export default proxy;